module.exports = __webpack_public_path__ + "img/hr-H-B-5-unload-standup-shadow.ecf80a1c.png";